import { State, initialState } from './activity.state';
import * as actions from './activity.actions';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function ActivityReducer(state = initialState, action: actions.Actions): State {

  switch (action.type) {

    case actions.activityTypes.LOAD_ACTIVITY: {

      const request = action.payload;
      return {
        ...state,
        filter: request.filter,
        isLoading: false
      };
    }

    case actions.activityTypes.LOAD_ACTIVITY_SUCCESS: {

      const report = action.payload;
      return {
        ...state,
        activityReport: report,
        isLoading: false
      };
    }

    case actions.activityTypes.CLEAR_ACTIVITY: {

      return {
        ...state,
        activityReport: null,
        isLoading: false
      };
    }
  }
  return state;
}
